export const handleWrongStatusCode = (res) => {
  if (res.status !== 200) {
    throw new Error(
      `${res.url.split('/').slice(3).join('/')}>${res.status}:${res.statusText}`
    );
  }

  return res;
};
